import styled from 'styled-components';

export const Styles = styled.div`
    @media only screen and (max-width: 600px) {
        .offers-body {
            margin-top: ${props => props.isLogged ? '' : ''}
        }
    }
`;